<template>
    <div class="sketch">
        <div class="sketch-sidebar">
            <M3SketchLeftPanel :companiesLength="companies ? companies.length : 0"></M3SketchLeftPanel>
        </div>
        <div class="sketch-frame">
            <M3SketchFrame :current-company-paid="currentCompanyPaid" :unsaved-changes="unsavedChanges" @changeCompany="changeCompanyId"></M3SketchFrame>
            <div class="sketch-content flex">
                <router-view
                    :rightFrameOpen="rightFrameOpen"
                    @changeProductIndicator="changeIndicator()"
                    @changePercentIndicator="changeIndicator()"
                    @unsavedChanges="unsavedChanges = $event"
                >
                </router-view>
                <M3SketchFrameRight v-if="!$route.path.includes('/licente')" :activeCompany="changeCId" @changeCompany="changeCompanyId($event)" @rightFrameOpen="rightFrameOpen = $event"></M3SketchFrameRight>
            </div>
        </div>
        <MobileDenyPopup :mobilePopup="modalShow"></MobileDenyPopup>

    </div>
</template>

<script>
    import LoadingSpinner from '@/common/components/LoadingSpinner'
    import M3SketchFrame from './components/M3SketchFrame'
    import MobileDenyPopup from './components/MobileDenyPopup'
    import M3SketchFrameRight from './components/M3SketchFrameRight'
    import M3SketchLeftPanel from './components/M3SketchLeftPanel'
    import { isMobileOnly } from 'mobile-device-detect';
    import _ from "lodash";
    import {BIconChevronUp} from 'bootstrap-vue'
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import smartlookClient from "smartlook-client";

    export default {
        name: 'M3Sketch',
        components: {
            LoadingSpinner,
            M3SketchFrame,
            MobileDenyPopup,
            M3SketchLeftPanel,
            M3SketchFrameRight,
            BIconChevronUp
        },

        data() {
            return {
                loading: true,
                modalShow: false,
                changeCId: null,
                currentCompanyPaid: false,
                totalScore: 0,
                unsavedChanges: false,
                consultant: null,
                rightFrameOpen: null,
            }
        },
        computed: {
            stateAids() {
                return this.$store.getters['stateAids/getStateAids']
            },
            currentM3Company() {
                return this.$store.getters['m3Sketch/m3Company'];
            },
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
            allData() {
                return this.$store.getters['m3Sketch/allData'];
            },
        },
        watch: {
            changeCId: {
                handler() {
                    if(this.currentM3Company){
                        this.getProjectData()
                        this.getProjectStats()
                        this.$emit('changedCId', this.changeCId)
                        this.currentCompanyPaid = JSON.parse(localStorage.getItem('currentM3Company')) ? JSON.parse(localStorage.getItem('currentM3Company')).paid : false
                    }
                },
                deep: false
            },
            allData: {
                handler() {
                    if(this.allData && this.allData.m3_project) {
                        let indicators = this.allData.m3_project.indicators ? this.allData.m3_project.indicators.indicators : null
                        if(indicators && !indicators.employees.number2019) {
                            axios.get(api.API_ENDPOINTS.m3 + JSON.parse(localStorage.getItem('currentM3Company')).business_id + '/v1')
                                .then(response => {
                                    if(response.data.nr_angajati_2019 < 1) {
                                        indicators.employees.number2019 = 1
                                    } else {
                                        indicators.employees.number2019 = response.data.nr_angajati_2019
                                    }
                                    this.indicatorsSend = {
                                        indicators: {
                                            indicators: indicators,
                                            checked: this.allData.m3_project.indicators.checked
                                        }
                                    }
                                    this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.indicatorsSend)
                                })
                        }
                    }
                }
            }
        },
        created() {
            if(process.env.NODE_ENV === 'production') {
                if(this.$store.getters['auth/user'] && !this.$store.getters['auth/user'].email.includes('@smis.ro') && !this.$store.getters['auth/user'].email.includes('filipbriscan')) {
                    smartlookClient.init('50b2598f449374b0f83cabb66ce93d4ce2b2d073', {region: 'eu', version: 'legacy'})
                    smartlookClient.consentAPI('api')
                    smartlookClient.consentIP('op')
                    smartlookClient.consentForms('forms')
                    if (this.$store.getters['auth/user']) {
                        smartlookClient.identify(this.$store.getters['auth/user'].id, {
                            name: this.$store.getters['auth/user'].name,
                            email: this.$store.getters['auth/user'].email,
                            m3_company_id: JSON.parse(localStorage.getItem('currentM3Company')).id
                        })
                    }
                }
            }
        },
        mounted() {
            this.$emit('sketchEntered')
            this.$store.dispatch('pageLoading/setLoading', true)
            if(!this.currentM3Company){
                if(JSON.parse(localStorage.getItem('currentM3Company')))
                    this.$store.dispatch('m3Sketch/setM3Company', JSON.parse(localStorage.getItem('currentM3Company')))
                else
                    this.$store.dispatch('m3Sketch/initializeM3Company');
            }
            if(!this.companies)
                this.$store.dispatch('m3Sketch/initializeCompanies')
                    .then(() => {
                        let currentCompany = this.currentM3Company
                        let apiCompany = _.filter(this.companies, v => v.id === currentCompany.id)[0]
                        if(currentCompany && apiCompany && currentCompany.paid !== apiCompany.paid){
                            localStorage.removeItem('currentM3Company')
                            currentCompany.paid = apiCompany.paid
                            this.currentCompanyPaid = apiCompany.paid
                            this.$store.dispatch('m3Sketch/setM3Company', currentCompany);
                        }
                    })

            if(JSON.parse(localStorage.getItem('currentM3Company')) !== undefined && JSON.parse(localStorage.getItem('currentM3Company')) !== null) {
                this.changeCId = JSON.parse(localStorage.getItem('currentM3Company')).id;
                this.currentCompanyPaid = JSON.parse(localStorage.getItem('currentM3Company')).paid
                this.$store.dispatch('checks/initializeChecks');
                this.$store.dispatch('pages/initializeCompletedPages');
            }

            if(isMobileOnly){
                this.modalShow = true
            }



        },

        methods: {

            changeCompanyId (company) {
                this.$store.dispatch('m3Sketch/setM3Company', company);
                if(company){
                    this.changeCId = company.id
                    this.$emit('changeCompany', company.business_id)
                }
            },

            getProjectData() {
                this.$store.dispatch('m3Sketch/initializeAllData');
            },

            getProjectStats() {
                this.$store.dispatch('m3Sketch/initializeIndicators');
            },
            changeIndicator() {
                this.getProjectStats()
            },
        }
    }
</script>
<style>
.flex{
    display: flex;
}
.padding-box{
    padding: 20px;
}
.wide-swall{
    width: 45.75em !important;
}
.wide-swall .swal2-html-container{
    margin: 0;
    padding: 45px 45px 0 45px;
}
.wide-swall .swal2-actions{
    justify-content: flex-start !important;
    margin: 5px 0 10px 38px !important;
}
.green {
	color: #49cda8;
}
/*.sketch-sidebar .menu-items > .menu-items:last-child ul .item{
    background: #f88c9b;
    color: #fff;
}*/
@media screen and (max-width: 1350px) {
    .sketch-content,
    .sketch-breadcrumb + .padding-box {
        height: 100%!important;
        padding-bottom: 50px!important;
    }
}
</style>

<style scoped>

</style>
